module.exports = "/images/dotag-logo.png?e6525210b2fe631480186c499c06f0dc";